<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.chart.menu.label.title')}}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="card-deck">

                        <div class="card"> <!--Pedidos-->
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel31.label.title')}} </h6>
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        <Orders />
                                    </div>
                                </div>
                            </div>    
                        </div>

                        <div class="card"> <!--????-->
                             <div class="card-body" style="text-align:center;">
                                 <!--<h6 class="card-title">{{$t('string.msg.rel31.label.title')}} </h6>-->
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Controller from './CrtChart';
import Orders from './Orders/Orders.vue';


export default {
    name: 'Chart',
    components: {
        Orders,
    },
    
     data() {
      return {
      }
     },
    
    methods: Controller.methods,

    created() {
    },
    mounted() {
        Controller.init(this);
    }
}
    </script>
